// extracted by mini-css-extract-plugin
module.exports = {"overview":"Overview-module--overview--z-9oh","list":"Overview-module--list--3VGrT","image":"Overview-module--image--3EeU7","text":"Overview-module--text--1m57u"};